import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, Observable, throwError } from "rxjs";
import { environment } from "src/environments/environment";
import { Category } from "../models/category.model";

let httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };

@Injectable({
    providedIn: "root",
  })

export class CategoryService {
    private categoriesUrl = environment.api + "Categories/";

    constructor(private http: HttpClient) {

    }

    //get

    public getAllCategories(): Observable<Category[]> {
        return this.http
          .get<Category[]>(this.categoriesUrl, httpOptions)
          .pipe(catchError(this.handleError));
      }

      private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          console.error("Fout:", error.error.message);
        } else {
          console.error(
            `Backend returned code Deze code voor handling ${error.status}` +
              ` body was: ${error.error}`
          );
        }
    
        return throwError("Something went wrong");
      }

}